module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "wrapper"
    }
  }, [_c('navigation'), _vm._v(" "), _c('div', {
    staticClass: "gray-bg",
    attrs: {
      "id": "page-wrapper"
    }
  }, [_c('top-bar'), _vm._v(" "), (_vm.havePageHeading) ? _c(_vm.headingComponent, {
    tag: "component"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.notLoading),
      expression: "notLoading"
    }],
    staticClass: "wrapper wrapper-content"
  }, [_c('router-view')], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "wrapper wrapper-content"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('strong', [_vm._v("Copyright")]), _vm._v(" Arrow Logistics " + _vm._s(_vm.currentYear) + "\n      ")])]), _vm._v(" "), _c('terms-and-conditions'), _vm._v(" "), (_vm.$user.isDisabled) ? _c('div', {
    staticClass: "modal fade modal-disabled-help",
    attrs: {
      "tabindex": "-1",
      "role": "dialog"
    }
  }, [_vm._m(0)]) : _vm._e()], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('i', {
    staticClass: "fa fa-question-circle"
  }), _vm._v(" Account Help")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', [_c('strong', [_vm._v("Account Disabled")])]), _vm._v(" "), _c('p', [_vm._v("\n              A disabled account has limited access to features and functionality of the Arrow Logistics application. Accounts may be automatically disabled if you have overdue invoices. Please contact Arrow Logistics administration for more information.\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('a', {
    staticClass: "btn btn-sm btn-default text-uppercase",
    attrs: {
      "href": "#",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_vm._v("Close")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-21d64734"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/templates/App.vue
// module id = 951
// module chunks = 0